import { useState } from 'react';
import { Button } from '../ui/button';
import { Download } from 'lucide-react';

export const ExportButton = ({ data, filename = 'export', columns, label = 'Export CSV' }) => {
  const [exporting, setExporting] = useState(false);

  const exportCSV = () => {
    if (!data || data.length === 0) return;
    setExporting(true);

    try {
      const headers = columns || Object.keys(data[0]);
      const csvRows = [headers.join(',')];

      data.forEach((row) => {
        const values = headers.map((h) => {
          const val = row[h] ?? '';
          const escaped = String(val).replace(/"/g, '""');
          return `"${escaped}"`;
        });
        csvRows.push(values.join(','));
      });

      const csvString = csvRows.join('\n');
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${filename}_${new Date().toISOString().split('T')[0]}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } finally {
      setExporting(false);
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={exportCSV}
      disabled={!data?.length || exporting}
      data-testid="export-csv-btn"
      className="text-xs"
    >
      <Download className="h-3.5 w-3.5 mr-1.5" />
      {exporting ? 'Exporting...' : label}
    </Button>
  );
};
